import React from 'react'
import './Style.css'
// import Logo from '../Images/Google-logo.png'
import Logo from '../Logo/1.png'
import Pic from '../Images/profile-pic.png'
import { Link } from 'react-router-dom'
import {
    Drawer,
    Button,
    Typography,
    IconButton,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    Chip,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";


export default function Navbar(props) {
    const [open, setOpen] = React.useState(false);
    const openDrawer = () => setOpen(true);
    const closeDrawer = () => setOpen(false);


    const [openD, setOpenD] = React.useState(false);

    const handleOpen = () => setOpenD(!openD);

    return (

        //  Navbar Main

        <nav className="navbar">
            <div className="nav-body">
                <div className="logo-container">
                    <img src={Logo} className="main-logo" alt="" />
                    <h1 className='nav-heading'>Ganitagya Classes</h1>
                </div>
                <div className="navlinks-container">
                    <Link to="/" className="nav-link">HOME</Link>
                    <Link to="/Schedule" className="nav-link">SCHEDULE  </Link>
                    <Link to="/contact" className="nav-link">CONTACT</Link>
                    <Link to="/courses" className="nav-link">COURSES</Link>
                    {/* <Link to="/ask" className="nav-link">ASK</Link> */}
                    <Link to="/questions" className="nav-link">QUESTIONS</Link>
                </div>
                <div className="class-btn">
                    <label class="hamburger" onClick={openDrawer}>
                        <input type="checkbox" />
                        <svg viewBox="0 0 32 32">
                            <path class="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
                            <path class="line" d="M7 16 27 16"></path>
                        </svg>
                    </label>
                    <img src={Pic} className="nav-profile" onClick={handleOpen} alt="" />
                </div>
            </div>




            {/* Modal */}
           
            <Dialog open={openD} handler={handleOpen}>
                <DialogHeader>Master Of Masters</DialogHeader>
                <DialogBody>
                   Hey, how u doin guyz !!
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={handleOpen}
                        className="mr-1"
                    >
                        <span>Good</span>
                    </Button>
                    <Button variant="gradient" color="green" onClick={handleOpen}>
                        <span>Great !!</span>
                    </Button>
                </DialogFooter>
            </Dialog>



            {/* Responsive Sidebar */}
            <div className="ham-menu">
                <React.Fragment>

                    <Drawer open={open} onClose={closeDrawer}>
                        <div className="mb-2 flex items-center justify-between p-4">
                            <Typography variant="h5" color="blue-gray">
                                <span className='urbanist-bold'>Ganitagya Classes</span>
                            </Typography>
                            <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="h-5 w-5"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </IconButton>
                        </div>
                        <List>
                            <Link to="/">  <ListItem>
                                <ListItemPrefix>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="M240-200h120v-200q0-17 11.5-28.5T400-440h160q17 0 28.5 11.5T600-400v200h120v-360L480-740 240-560v360Zm-80 0v-360q0-19 8.5-36t23.5-28l240-180q21-16 48-16t48 16l240 180q15 11 23.5 28t8.5 36v360q0 33-23.5 56.5T720-120H560q-17 0-28.5-11.5T520-160v-200h-80v200q0 17-11.5 28.5T400-120H240q-33 0-56.5-23.5T160-200Zm320-270Z" /></svg>
                                </ListItemPrefix>
                                <span className='urbanist'>Home</span>
                            </ListItem> </Link>
                            <Link to="/Schedule"> <ListItem>
                                <ListItemPrefix>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880q17 0 28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880q17 0 28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" /></svg>
                                </ListItemPrefix>
                                <span className='urbanist'>Schedule</span>
                                {/* <ListItemSuffix>
                                    <Chip
                                        value="5"
                                        size="sm"
                                        color="green"
                                        className="rounded-full"
                                    />
                                </ListItemSuffix> */}
                            </ListItem> </Link>
                            <Link to="/courses">
                                <ListItem>
                                    <ListItemPrefix>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="M440-400h80q17 0 28.5-11.5T560-440q0-17-11.5-28.5T520-480h-80q-17 0-28.5 11.5T400-440q0 17 11.5 28.5T440-400Zm0-120h240q17 0 28.5-11.5T720-560q0-17-11.5-28.5T680-600H440q-17 0-28.5 11.5T400-560q0 17 11.5 28.5T440-520Zm0-120h240q17 0 28.5-11.5T720-680q0-17-11.5-28.5T680-720H440q-17 0-28.5 11.5T400-680q0 17 11.5 28.5T440-640ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-520q0-17 11.5-28.5T120-720q17 0 28.5 11.5T160-680v520h520q17 0 28.5 11.5T720-120q0 17-11.5 28.5T680-80H160Zm160-720v480-480Z" /></svg>
                                    </ListItemPrefix>
                                    <span className='urbanist'>Courses</span>
                                </ListItem> </Link>
                            <Link to="/contact">
                                <ListItem>
                                    <ListItemPrefix>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="M600-520h200q17 0 28.5-11.5T840-560v-120q0-17-11.5-28.5T800-720H600q-17 0-28.5 11.5T560-680v120q0 17 11.5 28.5T600-520Zm100-90 74-52q8-6 17-1.5t9 14.5q0 1-7 14l-70 49q-11 8-23 8t-23-8l-70-49q-1-1-7-14 0-10 9-14.5t17 1.5l74 52ZM80-120q-33 0-56.5-23.5T0-200v-560q0-33 23.5-56.5T80-840h800q33 0 56.5 23.5T960-760v560q0 33-23.5 56.5T880-120H80Zm556-80h244v-560H80v560h4q42-75 116-117.5T360-360q86 0 160 42.5T636-200ZM360-400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM182-200h356q-34-38-80.5-59T360-280q-51 0-97 21t-81 59Zm178-280q-17 0-28.5-11.5T320-520q0-17 11.5-28.5T360-560q17 0 28.5 11.5T400-520q0 17-11.5 28.5T360-480Zm120 0Z" /></svg>
                                    </ListItemPrefix>
                                    <span className='urbanist'>Contact</span>
                                </ListItem>
                            </Link>
                            <Link to="/question/10">
                                <ListItem>
                                    <ListItemPrefix>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#434343"><path d="M200-400q-17 0-28.5-11.5T160-440q0-17 11.5-28.5T200-480h200q17 0 28.5 11.5T440-440q0 17-11.5 28.5T400-400H200Zm0-160q-17 0-28.5-11.5T160-600q0-17 11.5-28.5T200-640h360q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560H200Zm0-160q-17 0-28.5-11.5T160-760q0-17 11.5-28.5T200-800h360q17 0 28.5 11.5T600-760q0 17-11.5 28.5T560-720H200Zm320 520v-66q0-8 3-15.5t9-13.5l209-208q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L655-172q-6 6-13.5 9t-15.5 3h-66q-17 0-28.5-11.5T520-200Zm300-223-37-37 37 37ZM580-220h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" /></svg>
                                    </ListItemPrefix>
                                    <span className='urbanist'>Questions</span>
                                </ListItem>
                            </Link>
                        </List>
                        <Button className="mt-3 ml-5" size="sm">
                            Explore Now
                        </Button>
                    </Drawer>
                </React.Fragment>

            </div>

        </nav >


    )
}
